import { isOrderSeat } from '@vista-digital/ocapi-utilities';
import { joinArrayWith } from '@vista-digital/occ-domain';
import { createFilledArray, getLastElement, isEmptyArray } from '@vista-digital/utilities';
import { getConsecutiveSeatGroups } from './get-consecutive-seat-groups';
export const getFormattedSeatsSummary = (seats, displayText, i18n, requiredSeatCount) => {
    if (isEmptyArray(seats)) {
        return undefined;
    }
    const seatGroupLabels = getFormattedSeatGroupLabels(seats, displayText, i18n);
    if (!requiredSeatCount) {
        return seatGroupLabels.join(displayText.groupSeparator);
    }
    const extraSeats = requiredSeatCount - seats.length;
    const placeholderLabels = createFilledArray(displayText.placeholderLabel, extraSeats);
    const allSeatLabels = [...seatGroupLabels, ...placeholderLabels];
    return joinArrayWith(allSeatLabels, displayText.groupSeparator);
};
/**
 * Returns a formatted string label for a seat.
 */
export const getFormattedSeatLabel = (seat, displayText, i18n) => {
    return i18n.template(displayText.labelFormat, {
        seatLabel: isOrderSeat(seat) ? seat.seatLabel : seat.label,
        rowLabel: seat.rowLabel
    });
};
/**
 * Returns a formatted string label for a group of seats.
 */
export const getFormattedSeatGroupLabel = (seats, displayText, i18n) => {
    if (seats.length === 1) {
        return getFormattedSeatLabel(seats[0], displayText, i18n);
    }
    return i18n.template(displayText.groupFormat, {
        firstSeatLabel: getFormattedSeatLabel(seats[0], displayText, i18n),
        lastSeatLabel: getFormattedSeatLabel(getLastElement(seats), displayText, i18n)
    });
};
/**
 * Returns a formatted string summary of an array of seats.
 */
export function getFormattedSeatGroupLabels(seats, displayText, i18n) {
    if (seats.length === 0) {
        return [];
    }
    const seatGroups = getConsecutiveSeatGroups(seats);
    return seatGroups.map(seatGroup => getFormattedSeatGroupLabel(seatGroup, displayText, i18n));
}
/**
 * Returns a formatted string summary of an array of area names.
 */
export const getFormattedAreasSummary = (seats, displayText, i18n) => {
    if (seats.length === 0) {
        return undefined;
    }
    const uniqueAreaNames = new Set([...seats]
        .sort((a, b) => a.position.areaNumber - b.position.areaNumber)
        .map(seat => i18n.translatable(seat.areaName)));
    return Array.from(uniqueAreaNames).join(displayText.areaNameSeparator);
};
//# sourceMappingURL=seat-utils.js.map